import { useMemo, type PropsWithChildren } from "react";
import { CONFIG_HEADER_APPLICATIONS_BY_ENVIRONMENT } from "../configs/header";
import { ConfigStateContext, type ConfigContextState } from "./context-config";

export type ConfigStateProviderProps = Omit<ConfigContextState, "applications">;

export function ConfigStateProvider(
  props: PropsWithChildren<ConfigStateProviderProps>,
) {
  const value = useMemo<ConfigContextState>(
    () => ({
      ...props,
      applications:
        CONFIG_HEADER_APPLICATIONS_BY_ENVIRONMENT[props.environment],
    }),
    [props],
  );

  return (
    <ConfigStateContext.Provider value={value}>
      {props.children}
    </ConfigStateContext.Provider>
  );
}
